import { createFileRoute } from "@tanstack/react-router";
import Formularios from "@/pages/admin/Formularios";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/admin/formularios/")({
  head: () => pageHead({ title: "Formulários | Painel", path: "/admin/formularios", noindex: true }),
  component: Formularios,
});
